import { Link } from "react-router-dom";
import { unwrapRepeater } from "../../utils/CockpitUtils";
import Icon from "../Icon";
import "./link-list.scss";

const LinkList = ({ type = "small", items = [], heading = "" }) => {
  items = unwrapRepeater(items);
  const isExternalUrl = /^https?:\/\//i;

  return (
    <div className={`${type} icon-list`}>
      {heading && <h3>{heading}</h3>}
      <ul>
        {items.map((link, j) => (
          <li key={j}>
            {isExternalUrl.test(link.url) ? (
              <a href={link.url} target="_blank" rel="noreferrer">
                <Icon
                  className="icon"
                  type={link.icon_style || "far"}
                  name={link.icon}
                />
                <span className="title">{link.text}</span>
                {type !== "large" && (
                  <Icon name="chevron-right" type="fal" className="more-icon" />
                )}
              </a>
            ) : link.url ? (
              <Link to={link.url}>
                <Icon
                  className="icon"
                  type={link.icon_style || "far"}
                  name={link.icon}
                />
                <span className="title">{link.text}</span>
                {type !== "large" && (
                  <Icon name="chevron-right" type="fal" className="more-icon" />
                )}
              </Link>
            ) : (
              <span className="link-placeholder">
                <Icon
                  className="icon"
                  type={link.icon_style || "far"}
                  name={link.icon}
                />
                <span className="title">{link.text}</span>
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LinkList;
